export const MAP_TYPES = {
  STANDARD: 'STANDARD',
  HEAT: 'HEAT',
  COLOR: 'COLOR',
  SIZE: 'SIZE',
};
